"use strict";
// Shared DTOs for the Jira integration.
Object.defineProperty(exports, "__esModule", { value: true });
